import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Close as CloseIcon } from '@material-ui/icons';
import { Dialog as MaterialDialog, Grid, Portal } from '@material-ui/core';
import { FeatureUpselling as FeatureUpsellingModule } from '@dev/ee-modules';
import { BillingPlan, ProductCode } from '@dev/ee-api/ee-api-models';
import { isEmpty } from 'lodash';
import { ElasticTheme } from '@dev/ee-components';
import { useMobile } from '@/services/hooks/useMobile';
import { SetToastPortalWrapper } from '@/store/toast/actions';
import { CloseUpsellingOverlay, getPaidNewsletterCreatorStore } from '@/store/paidNewsletterCreator/actions';
import { getBillingPlanList, GetBillingPlans } from '@/store/products/actions';
import { BillingPaths, pathsParams } from '@/services/dictionaries/Paths';
import { useActivePlan } from '@/services/hooks/useActivePlan';
import { CloseIconContainer, Overlay } from './styles';

const landingPageCreatorUpsellingOverlayContainerId = 'landingPageCreatorUpsellingOverlay';

export const UpsellingOverlay = (): JSX.Element => {
    const dispatch = useDispatch();
    const isMobile = useMobile();
    const { openUpsellingFeature } = useSelector(getPaidNewsletterCreatorStore);
    const billingPlans: BillingPlan[] = useSelector(getBillingPlanList) || [];
    const { Code } = useActivePlan();

    useEffect(() => {
        if (Code && isEmpty(billingPlans)) {
            dispatch(GetBillingPlans(Code));
        }
    }, [Code]);

    const close = (): void => {
        dispatch(CloseUpsellingOverlay());
    };

    useEffect(() => {
        if (openUpsellingFeature) {
            dispatch(SetToastPortalWrapper(true));
        }
        return () => {
            dispatch(SetToastPortalWrapper(false));
        };
    }, [openUpsellingFeature]);

    return (
        <Portal>
            <MaterialDialog
                open={!!openUpsellingFeature}
                fullScreen
                scroll="body"
                id={landingPageCreatorUpsellingOverlayContainerId}
                style={{ zIndex: ElasticTheme.zIndex.tooltip + 1 }}
            >
                <Overlay>
                    <CloseIconContainer>
                        <CloseIcon fontSize="large" onClick={close} />
                    </CloseIconContainer>
                    <Grid container justifyContent="center" style={{ padding: '0px 16px' }}>
                        <Grid item xs={12} sm={12} style={{ maxWidth: 1170, paddingBottom: 16 }}>
                            <FeatureUpsellingModule
                                feature={openUpsellingFeature}
                                isMobile={isMobile}
                                billingPathname={BillingPaths.BillingPlanList.replace(
                                    pathsParams.productCode,
                                    Code?.toLowerCase() || ProductCode.Marketing.toLowerCase()
                                )}
                            />
                        </Grid>
                    </Grid>
                </Overlay>
            </MaterialDialog>
        </Portal>
    );
};
